import { getAdoptableWidgetConfig } from './ShopAll.deviation_gruser/AdoptableSlider/widgetConfig';
import { getCommissionWidgetConfig } from './ShopAll.deviation_gruser/CommissionSlider/widgetConfig';
import { getPremiumContentWidgetConfig } from './ShopAll.deviation_gruser/PremiumContentSlider/widgetConfig';
import { getPremiumFolderWidgetConfig } from './ShopAll.deviation_gruser/PremiumFolderSlider/widgetConfig';

export const getShopWidgetConfigs = ({ t, dispatch }) => ({
  commissions: getCommissionWidgetConfig({ t, dispatch }),
  adoptables: getAdoptableWidgetConfig({ t, dispatch }),
  premiumContent: getPremiumContentWidgetConfig({ t, dispatch }),
  premiumFolders: getPremiumFolderWidgetConfig({ t, dispatch }),
});
